import {ref, shallowRef} from "vue";

//@ts-ignore
export const app_url = import.meta.env?.VITE_APP_URL ?? 'localhost:80';
export const is_mounted = ref(false);

export const current_layout = ref('empty');
export const current_layout_component = shallowRef(null);
